import React, { ReactNode } from "react";
import styled from "styled-components";
import { HorizontalAlignment } from "../../../components/types";
import Rating from "../Rating/Rating";

//Used to insert a quote text & quote author.

//Properties:
//Quote text
//Author
//Horizontal alignment

//Usage:
/*
<Review source="Gaffa" ratingvalue={1} maxRatingvalue={6}>
    <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."</p>
</Review>
*/

interface Props {
    source: string;
    children: ReactNode;
    horizontalAlign?: HorizontalAlignment;
    ratingValue: number;
    maxRatingValue: number;
    starColor?: string;
}

const ReviewWrap = styled.div<Props>`
    position: relative;
    margin-bottom: 2.5rem;
    text-align: ${props =>
        (props.horizontalAlign === "left") ? "left" :
            (props.horizontalAlign === "center") ? "center" :
                (props.horizontalAlign === "right") ? "right" :
                    "inherit"
};
`;

const ReviewText = styled.div`
    position: relative;
    letter-spacing: .025;
    p {
        margin-bottom: 0.5rem;
    }

    &.noStars {
        margin-top: 2.1rem;
    }

`;

const ReviewFooter = styled.footer`
    display: flex;
    align-items: flex-start;
    width: 100%;
`;

const ReviewCite = styled.cite`
    font-style: normal;
    text-transform: uppercase;
    margin-left: 0.3rem;
    max-width: 190px;
`;

const ReviewAuthor = styled.span`
    font-size: var(--text-xs, .7333rem);
    letter-spacing: 0.025em;
    margin-bottom: .5rem;
    font-weight: bold;
`;

const Dash = styled.span`
    display: inline-block;
    background-color: currentColor;
    height: 1px;
    width: 0.5rem;
    margin-top: 0.55rem;
`;

const Review = (props: Props) =>
{
    const anyStars = props.ratingValue && props.maxRatingValue;
    return(
        <ReviewWrap {...props}>
            {anyStars ?
                <Rating
                    value={props.ratingValue}
                    maxValue={props.maxRatingValue}
                    starColor={props.starColor} />
                    : null }
            <ReviewText className={!anyStars ? "noStars" : ""}>
                    {props.children}
            </ReviewText>

            {props.source ?
                <ReviewFooter>
                    <Dash />
                    <ReviewCite>
                        <ReviewAuthor><p>{props.source}</p></ReviewAuthor>
                    </ReviewCite>
                </ReviewFooter>
                : null }
        </ReviewWrap>
    );
};

export default Review;